import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button } from 'antd';
import { Action, AnyObject } from '@triare/auth-redux';
import {
  signInByService as signInByServiceAction,
  SignInByServiceAction,
} from '@triare/auth-redux/dist/saga/auth/signIn';
import { useTranslation } from 'react-i18next';
import { IResolveParams, LoginSocialGoogle } from 'reactjs-social-login';
import { Error } from '@triare/auth-redux/dist/saga/common';
import { ContentProps } from '../../index';
import { moduleName } from '../../../../../../store/auth';
import { RootState } from '../../../../../../store';
import { IconGoogle } from '../../../../../Common/Icon';

interface ButtonGoogleProps extends ContentProps {
  response: AnyObject | null;
  error: Error | null;
  signInByService: (payload: SignInByServiceAction) => Action;
  label?: string;
}

const client_id = process.env.REACT_APP_GG_APP_ID || '';

function ButtonGoogle({
  error,
  response,
  onSubmit,
  signInByService,
  label,
}: ButtonGoogleProps): React.ReactElement {
  const [signInData, setSignInData] = useState<SignInByServiceAction | null>(
    null
  );
  const { t } = useTranslation();

  useEffect(() => {
    if (!error && response && onSubmit && signInData) {
      onSubmit(signInData);
    }
  }, [response, error, onSubmit, signInData]);

  return (
    <LoginSocialGoogle
      isOnlyGetToken
      client_id={client_id}
      scope="openid email"
      onResolve={({ data }: IResolveParams) => {
        if (data && data.access_token) {
          const payload: SignInByServiceAction = {
            method: 'google',
            accessToken: data.access_token,
          };

          setSignInData(payload);
          signInByService(payload);
        }
      }}
      onReject={(err) => {
        console.log('Google err:', err);
      }}
    >
      <Button
        style={{ width: '100%', fontWeight: 600, color: '#282C35' }}
        size="large"
        icon={<IconGoogle />}
      >
        {label || 'Log in with Google'}
      </Button>
    </LoginSocialGoogle>
  );
}

export default connect(
  (state: RootState) => ({
    response: state[moduleName].signIn.response,
    error: state[moduleName].signIn.error,
  }),
  {
    signInByService: signInByServiceAction,
  }
)(ButtonGoogle);
